import { render } from "./SupportFeesModal.vue?vue&type=template&id=2faa3c3d&scoped=true"
import script from "./SupportFeesModal.vue?vue&type=script&lang=js"
export * from "./SupportFeesModal.vue?vue&type=script&lang=js"

import "./SupportFeesModal.vue?vue&type=style&index=0&id=2faa3c3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2faa3c3d"]])

export default __exports__